var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fade } from '@mui/material';
import { DatePicker as MuiDatePicker, } from '@mui/x-date-pickers/DatePicker';
import { Date16, ExpandLeft12, ExpandRight12 } from '@yunex/yds-icons';
import React, { useCallback, useMemo } from 'react';
import { PickersCalendarHeader } from './CalendarHeader';
import { DateField } from './DateField';
import { CustomActionBar, DayRenderer, IconButton, SwitchViewButton } from './SharedSlots';
/**
 * Custom components for DatePicker.
 * See [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/#slots) for more details.
 */
export var DatePickerSlots = {
    openPickerIcon: Date16,
    openPickerButton: IconButton,
    rightArrowIcon: ExpandRight12,
    leftArrowIcon: ExpandLeft12,
    nextIconButton: function (_a) {
        var ownerState = _a.ownerState, props = __rest(_a, ["ownerState"]);
        return (React.createElement(Fade, { in: ownerState['data-current-view'] === 'day' },
            React.createElement(IconButton, __assign({}, props, { disabled: ownerState.isNextDisabled, "aria-label": ownerState.nextLabel }))));
    },
    previousIconButton: function (_a) {
        var ownerState = _a.ownerState, props = __rest(_a, ["ownerState"]);
        return (React.createElement(Fade, { in: ownerState['data-current-view'] === 'day' },
            React.createElement(IconButton, __assign({}, props, { disabled: ownerState.isPreviousDisabled, "aria-label": ownerState.previousLabel }))));
    },
    switchViewButton: SwitchViewButton,
    switchViewIcon: function () { return null; },
    toolbar: function () { return null; },
    actionBar: CustomActionBar,
    field: DateField,
    day: DayRenderer,
    calendarHeader: function (props) { return React.createElement(PickersCalendarHeader, __assign({}, props)); },
};
export function DatePicker(props) {
    var dayOfWeekFormatterDefault = useCallback(function (day) { return day.charAt(0).toUpperCase() + day.charAt(1); }, []);
    var memoSlots = useMemo(function () { return (__assign(__assign({}, props === null || props === void 0 ? void 0 : props.slots), DatePickerSlots)); }, [props === null || props === void 0 ? void 0 : props.slots]);
    return (React.createElement(MuiDatePicker, __assign({ views: ['month', 'year', 'day'], openTo: "day", dayOfWeekFormatter: dayOfWeekFormatterDefault }, props, { slots: memoSlots })));
}
export default DatePicker;
